<template>
  <AtomicUiSlideout id="sort-and-filter" title="Sort & Filter" position="right" :sticky-header="true" @close-slideout="closeSlideout">
    <div class="grid-x grid-margin-x margin-bottom-s sticky-buttons">
      <div class="cell small-6">
        <AtomicUiButton variant="secondary" :expanded="true" :disabled="clearDisabled" @click.prevent="clearAllSelectedFacets">
          Clear All
        </AtomicUiButton>
      </div>
      <div class="cell small-6">
        <AtomicUiButton variant="primary" :expanded="true" @click.prevent="applyFilter"> Apply </AtomicUiButton>
      </div>
    </div>
    <SortByCriteria />
    <p class="large margin-top-m margin-bottom-s">Filter By</p>
    <AtomicUiAccordion ref="accordionEl" :active-index="accordionActiveIndex" size="medium">
      <AtomicUiAccordionTab v-for="tab in accordionTabs" :key="tab.id" :header="tab.id">
        <CriteriaWrapper :name="tab.id" />
      </AtomicUiAccordionTab>
    </AtomicUiAccordion>
  </AtomicUiSlideout>
</template>

<script setup>
import SortByCriteria from '~/components/FilteringFacets/SortByCriteria';
import CriteriaWrapper from '~/components/FilteringFacets/Criteria/CriteriaWrapper';
import { GET_ALL_SELECTED_CRITERIA, UPDATE_SORTBY_SELECTED, REPLACE_SELECTED_VALUES, ADD_CHECKBOX_VALUES } from '~/types/actions';
import useSortFilter from '~/composables/filteringFacets/useSortFilter';
import { useFilteringFacetsStore } from '~/stores/filteringFacets';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

const filteringFacetsStore = useFilteringFacetsStore();
const slideoutStore = useSlideoutStore();

const accordionEl = ref(null);
const { resetSelections, selections, clearAllSelectedFacets } = useSortFilter();

const closeSlideout = () => {
  resetSelections();
};

const accordionTabs = computed(() =>
  selections.value.facets.map((facet) => ({
    id: facet.name,
  })),
);

const clearDisabled = computed(() => selections.value.facets.filter((facet) => facet.selectedValues.length > 0).length === 0);

const accordionActiveIndex = computed(() => selections.value.accordionActiveIndex);

watch(accordionActiveIndex, () => {
  nextTick(() => {
    const accordionActiveEl = accordionEl.value.$el.querySelector('.p-accordion-tab.p-accordion-tab-active');
    if (accordionActiveEl != null) {
      accordionActiveEl.scrollIntoView(false);
    }
  });
});

const applyFilter = () => {
  slideoutStore.close('sort-and-filter');
  filteringFacetsStore[UPDATE_SORTBY_SELECTED](selections.value.sortBySelectedValue);
  selections.value.facets.forEach((facet) => {
    if (facet.name === 'Price') {
      const customPrice = facet.values.filter((value) => value.label.indexOf('Custom:') > -1);
      if (customPrice.length > 0) {
        filteringFacetsStore[ADD_CHECKBOX_VALUES]({
          name: facet.name,
          newValue: {
            label: customPrice[0].label,
            value: customPrice[0].value,
          },
        });
      }
      filteringFacetsStore[REPLACE_SELECTED_VALUES]({
        name: facet.name,
        selectedValues: facet.selectedValues,
      });
    } else {
      filteringFacetsStore[REPLACE_SELECTED_VALUES]({
        name: facet.name,
        selectedValues: facet.selectedValues,
      });
    }
  });
  filteringFacetsStore[GET_ALL_SELECTED_CRITERIA]();
};
</script>

<style lang="scss" scoped>
.sticky-buttons {
  position: sticky;
  padding-bottom: rem-calc(20);
  top: rem-calc(90);
  z-index: 30;
  background: $white;
}
</style>
